<template>
  <div class="game">
    <slot name="lottery"></slot>
    <slot name="exclusive"></slot>
    <slot name="showCoupon"></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.game {
  background: url(~@this/assets/image-12.png) no-repeat;
  background-size: 100% 100%;
  width: 710px;
  padding: 30px 20px 0;
}
</style>
